import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box, Divider } from '@material-ui/core';
import { helpStyles } from '../Help';
import srcSelectMenu from '../../../img/help/help_select_menu.jpg';
import srcBusinessJobMenu from '../../../img/help/help_business_job_menu.jpg';
import srcBusinessJobUpdate from '../../../img/help/help_business_job_update.jpg';

const useStyles = makeStyles((theme) => ({
    container: {
        width: '100%',
    },
    ...helpStyles,
}));

const HelpBusinessJobUpdate = () => {
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <Typography variant="body1" className={classes.helpLine}>
                ・画面右上、メニューをクリックまたはタップします
            </Typography>
            <Box className={classes.helpImage}>
                <img src={srcSelectMenu} alt="Select menu" className={classes.helpImageStyle} />
            </Box>

            <Divider className={classes.helpDivider} />

            <Typography variant="body1" className={classes.helpLine}>
                ・メニューから『求人投稿・編集』を選択し、編集ページへ移動します。
            </Typography>
            <Box className={classes.helpImage}>
                <img src={srcBusinessJobMenu} alt="Business job menu" className={classes.helpImageStyle} />
            </Box>

            <Divider className={classes.helpDivider} />

            <Typography variant="body1" className={classes.helpLine}>
                『この求人を再告知する』ボタンをクリックします。
            </Typography>
            <Box className={classes.helpImage}>
                <img src={srcBusinessJobUpdate} alt="Business job update" className={classes.helpImageStyle} />
            </Box>

            <Typography variant="body1" className={classes.helpLine}>
                その後確認画面が表示された時に『OK』ボタンを押すと、求人広告の更新日が変更され、
                <a href="https://twitter.com/nzworks_jp" className={classes.helpLink} target="_blank" rel="noopener noreferrer">
                    NZワークス専用ツイッター
                </a>
                及び
                <a href="https://www.facebook.com/nzworksjp/" className={classes.helpLink} target="_blank" rel="noopener noreferrer">
                    Facebook
                </a>
                にも自動的に情報が投稿されます。
            </Typography>

            <Typography variant="body1" className={classes.helpInfoText}>
                ※再告知ボタンは一度使用すると２週間の間使えなくなります。
            </Typography>
        </Box>
    )
}

export default HelpBusinessJobUpdate
